// events

// Homepage
window.clickOnResultsCta = function (count = "x") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "uaevent",
        "eventCategory": "Content",
        "eventAction": "Redirection::Internal",
        "eventLabel": "Zobrazit " + count + " vozů"
    });
    console.log('clickOnResultsCta(' + count + ')');
    return true;
}

// Results page
window.clickOnLinkCta = function (linkLabel = "Zobrazit") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "uaevent",
        "eventCategory": "Content",
        "eventAction": "Redirection::Internal",
        "eventLabel": linkLabel
    });
    console.log('clickOnLinkCta(' + linkLabel + ')');
}

// Vehicle details page
window.clickOnSubmissionButton = function (formName = "contact-form") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "uaevent",
        "eventCategory": "Content",
        "eventAction": "Validate::" + formName,
        "eventLabel": "Odeslat poptávku"
    });
    console.log('clickOnSubmissionButton(' + formName + ')');
}

// Vehicle details page
window.clickToDownloadPdf = function (id) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "uaevent",
        "eventCategory": "Content",
        "eventAction": "Download",
        "eventLabel": id + ".pdf"
    });
    console.log('clickToDownloadPdf()');
}

// Vehicle details page
window.clickToPrint = function (id) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "uaevent",
        "eventCategory": "Content",
        "eventAction": "Print",
        "eventLabel": id
    });
    
    console.log('clickToPrint()');

    window.print();
}

// Vehicle details page
window.clickToShareByEmail = function (formName = "sendmail") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "uaevent",
        "eventCategory": "Content",
        "eventAction": "Validate::" + formName,
        "eventLabel": "Odeslat"
    });

    console.log('clickToShareByEmail()');
    
    return true;
}
